// import React from 'react';
// import cl from './LoaderAni.module.css'


// const LoaderAni = ({ mode, ...props }) => {
//     return (
//         <div {...props} className={cl.myBtn}>
//             <div className={cl.loadingPlaceholder} style={{ marginTop: 10 }}>
//                 <div className={cl.loadingSpinner}></div>
//             </div>
//         </div>
//     )
// };

// export default LoaderAni;11


// // Темный режим (по умолчанию)
// <LoaderAni mode="dark" text="Загрузка мира..." />

// // Светлый режим
// <LoaderAni mode="light" text="Генерация блоков..." />

// // Большой размер
// <LoaderAni 
//     mode="dark" 
//     size="large" 
//     text="Создание школы программирования..." 
// />

// // Для Header
// <LoaderAni 
//     mode="light" 
//     size="small" 
//     text="Майнинг знаний..." 
// />

// // Без текста
// <LoaderAni mode="dark" showText={false} />



import React from 'react';
import cl from './LoaderAni.module.css';

const LoaderAni = ({
    mode = 'dark', // 'dark' (#222831) или 'light' (#FBD46D)
    size = 'medium', // 'small', 'medium', 'large'
    text = 'Загрузка...',
    showText = true,
    className = ''
}) => {
    return (
        <div className={`${cl.loaderContainer} ${cl[mode]} ${cl[size]} ${className}`}>
            {/* Майнкрафт блоки */}
            <div className={cl.minecraftBlocks}>
                <div className={`${cl.block} ${cl.block1}`}>
                    <div className={cl.blockFace}></div>
                </div>
                <div className={`${cl.block} ${cl.block2}`}>
                    <div className={cl.blockFace}></div>
                </div>
                <div className={`${cl.block} ${cl.block3}`}>
                    <div className={cl.blockFace}></div>
                </div>
                <div className={`${cl.block} ${cl.block4}`}>
                    <div className={cl.blockFace}></div>
                </div>
            </div>

            {/* Пиксельная анимация прогресс бара */}
            <div className={cl.progressContainer}>
                <div className={cl.progressBar}>
                    <div className={cl.progressFill}></div>
                    <div className={cl.progressPixels}>
                        {Array.from({ length: 10 }, (_, i) => (
                            <div
                                key={i}
                                className={`${cl.pixel} ${cl[`pixel${i + 1}`]}`}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Minecraft-style текст */}
            {showText && (
                <div className={cl.minecraftText}>
                    <span
                        style={mode === 'dark' ? { color: 'black' } : undefined}
                        className={cl.text}
                    >
                        {text}
                    </span>
                    <div className={cl.dots}>
                        <span className={`${cl.dot} ${cl.dot1}`}>▪</span>
                        <span className={`${cl.dot} ${cl.dot2}`}>▪</span>
                        <span className={`${cl.dot} ${cl.dot3}`}>▪</span>
                    </div>
                </div>
            )}

            {/* Пиксельные частицы */}
            <div className={cl.particles}>
                {Array.from({ length: 8 }, (_, i) => (
                    <div
                        key={i}
                        className={`${cl.particle} ${cl[`particle${i + 1}`]}`}
                    ></div>
                ))}
            </div>

            {/* Центральный Minecraft логотип/иконка */}
            <div className={cl.centerLogo}>
                <div className={cl.pickaxe}>
                    <div className={cl.pickaxeHandle}></div>
                    <div className={cl.pickaxeHead}></div>
                </div>
            </div>
        </div>
    );
};

export default LoaderAni;